<template>
  <div class="row" id="diagnostico-situacional">
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Dashboard">
          <template v-slot:title>
            <i class="icofont-chart-histogram"></i> Dashboard
          </template>
          <dashboard
            :cadastros="dadosDashboard"
            :dadosEscore="dadosEscore"
            :loadingPage="loading"
          ></dashboard>
        </b-tab>
        <b-tab title="Escore">
          <template v-slot:title>
            <i class="icofont-chart-histogram"></i> Escore
          </template>
          <tabela-escore
            ref="table"
            :cadastros="displayedEscore"
            :loading="loading"
            @filterSearch="filterSearch($event)"
          ></tabela-escore>
        </b-tab>
        <b-tab title="Percentual">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Percentual
          </template>
          <tabela-percentual
            ref="table"
            :cadastros="displayedPercentual"
            :loading="loading"
            @filterSearch="filterSearch($event)"
          ></tabela-percentual>
        </b-tab>
        <b-tab title="Equipes" @click="buscarDadosDoMapa()">
          <template v-slot:title>
            <i class="icofont-ui-map"></i> Equipes
          </template>
          <div class="row">
            <mapa :dadosResultado="dadosResultado" ref="mapa" />
          </div>
          <div class="input-map-selected">
            <div class="caption-map">
              <span class="caption-item c-orange"></span>
              <span>Cadastro e-SUS &lt; parâmetro</span>
              <span class="caption-item c-green"></span>
              <span>Cadastro e-SUS &gt;= parâmetro e &lt;= máximo</span>
              <span class="caption-item c-red"></span>
              <span>Cadastro e-SUS &gt; máximo</span>
            </div>
            <button
              class="btn"
              @click="atualizarLocalizacaoDasUbsDoMunicipio()"
            >
              <b-spinner
                small
                label="Small Spinner"
                variant="white"
                v-if="loadingLocalizacaoUbs"
              ></b-spinner>
              <span> Atualizar localização</span>
            </button>
          </div>
          <tabela-pessoas-por-equipe
            :cadastros="dadosTabelaPessoasPorEquipe"
          ></tabela-pessoas-por-equipe>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import utils from '@/mixins/utils.js'
import TitleTag from '@/components/TitleTag.vue'
import TabelaPercentual from './TabelaPercentual.vue'
import Mapa from './Mapa.vue'
import TabelaEscore from './TabelaEscore.vue'
import TabelaPessoasPorEquipe from './TabelaPessoasPorEquipe.vue'
import Dashboard from './Dashboard'

export default {
  name: 'DiagnosticoSituacional',
  components: {
    Subtitle,
    TitleTag,
    PulseLoader,
    TabelaPercentual,
    Mapa,
    TabelaEscore,
    TabelaPessoasPorEquipe,
    Dashboard,
  },
  mixins: [utils],
  data() {
    return {
      loading: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      tabsActive: 0,
      filterSearchTable: false,
      setRed: false,
      dadosResultado: [],
      dadosDasEquipes: [],
      dadosPercentual: [],
      dadosEscore: [],
      dadosAcompanhamento: [],
      dadosTabelaPessoasPorEquipe: [],
      loadingLocalizacaoUbs: false,
      dadosDashboard: [],
    }
  },
  computed: {
    displayedPercentual() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      let response = Filter.filtro(
        this.dadosPercentual,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
    displayedEscore() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      let response = Filter.filtro(
        this.dadosEscore,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
  },
  methods: {
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (vermelho === true) {
        this.setRed = true
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        this.setRed = false
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
    },

    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    buscarDadosTabelaPessoasPorEquipe() {
      this.dadosTabelaPessoasPorEquipe = this.dadosResultado.filter((item) => {
        return item.ine !== null
      })
    },

    buscarDadosDoMapa() {
      this.$refs.mapa.initMap()
    },

    async buscarDadosIniciais() {
      try {
        this.loading = true

        // escore
        let response4 = await this.$api.get(
          `/app/v2/diagnostico-situacional/${this.$store.state.cod_ibge}/escore/[35,36,37,54,55,56]`
        )
        if (response4) {
          this.dadosEscore = response4.data
          this.dadosPercentual = response4.data
          this.dadosDashboard = response4.data
        }

        // percentual
        let response3 = await this.$api.get(
          `/app/v2/diagnostico-situacional/${this.$store.state.cod_ibge}/percentual/[0,27,28,29,30,31,32,33]`
        )
        if (response3) {
          this.dadosPercentual = response3.data
        }

        let response2 = await this.$api.get(
          '/app/utils/equipes-br/' + this.$store.state.cod_ibge
        )
        if (response2) {
          this.dadosResultado = response2.data
          this.buscarDadosTabelaPessoasPorEquipe()
          this.buscarDadosDoMapa()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async atualizarLocalizacaoDasUbsDoMunicipio() {
      try {
        this.loadingLocalizacaoUbs = true
        let ubsDoMunicipio = []
        const response = await this.$apiPublic.get(
          '/cofinanciamento-federal-aps/ubs/' + this.$store.state.cod_ibge
        )
        if (response) {
          ubsDoMunicipio = response.data
        }

        if (ubsDoMunicipio.length > 0) {
          let ultimaAtualizacao = ubsDoMunicipio[0].updated_at.split(' ')[0]
          const diferencaDias = this.diffDays(ultimaAtualizacao)
          if (diferencaDias < 2) {
            this.$toast.warning(
              'Localização atualizada recentemente, por favor, tentar novamente em 3 dias.',
              'Atenção:',
              {
                position: 'topRight',
              }
            )
            this.loadingLocalizacaoUbs = false
            return
          }

          for (let index = 0; index < ubsDoMunicipio.length; index++) {
            const element = ubsDoMunicipio[index]
            try {
              const response = await this.$apiPublic.put(
                '/cofinanciamento-federal-aps/ubs/localizacao',
                {
                  cnes: element.cnes,
                }
              )
              if (response.data.error == true) {
                console.log('Erro ao atualizar localização')
              }
            } catch (innerError) {
              console.log(
                `Erro ao atualizar localização para o CNES: ${element.cnes}`,
                innerError
              )
            }
          }
          this.$toast.success(
            'Localização atualizada com sucesso!',
            'Sucesso:',
            {
              position: 'topRight',
            }
          )
          this.buscarDadosDoMapa()
          this.loadingLocalizacaoUbs = false
        }
      } catch (error) {
        console.log(error)
        this.loadingLocalizacaoUbs = false
      }
    },

    init() {
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
.map-radius {
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #fff;
  font-weight: 700;
}
</style>

<style src="./styles.scss" scoped lang="scss" />
